import * as React from 'react';
import style from './Modal.scss';
import { createPortal } from 'react-dom';

const shouldRenderModal = () =>
  typeof window !== 'undefined' && typeof document !== 'undefined';

const addModalAnchor = () => {
  let modalContainer = document.getElementById('modal-root');
  if (!modalContainer) {
    modalContainer = document.createElement('div');
    modalContainer.setAttribute('id', 'modal-root');
    document.body.appendChild(modalContainer);
  }
  return modalContainer;
};

export class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.modalRoot = shouldRenderModal() && addModalAnchor();
    this.el = shouldRenderModal() && document.createElement('div');
    this.modalWrapperRef = React.createRef();
  }

  onClickHandler = (e) => {
    // detect clicks outside of the modal
    if (e.target === this.modalWrapperRef.current) {
      this.props.closeModal && this.props.closeModal();
      return;
    }
  };

  closeModalOnESC = (e) => {
    if (e.key === 'Escape') {
      this.props.closeModal();
    }
  };

  componentDidMount() {
    this.modalRoot && this.modalRoot.appendChild(this.el);
    window.addEventListener('keyup', this.closeModalOnESC);
  }

  componentWillUnmount() {
    this.modalRoot && this.modalRoot.removeChild(this.el);
    window.removeEventListener('keyup', this.closeModalOnESC);
  }

  shouldShowModal = () => shouldRenderModal() && this.props.isOpen;

  render() {
    return (
      this.shouldShowModal() &&
      createPortal(
        <div
          data-hook={this.props.dataHook || 'modal'}
          className={style.fullScreenModal}
          onClick={this.onClickHandler}
          ref={this.modalWrapperRef}
        >
          {this.props.children}
        </div>,
        this.el,
      )
    );
  }
}
